import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-sm font-semibold text-gray-700" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-gray-400 italic"
}
const _hoisted_3 = {
  key: 1,
  class: "text-sm text-gray-400 italic"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "text-2xl font-semibold text-gray-900" }
const _hoisted_6 = {
  key: 0,
  class: "mt-1 text-[13px] leading-relaxed text-gray-500"
}

import Cookies from 'js-cookie'
import { computed, onMounted, ref } from 'vue'

import NeueButton from '@/components/neue/NeueButton'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import { useSettingsAccess } from '@/composables/useSettingsAccess'
import api from '@/store/api'
import SettingsShell from '@/view/settings/SettingsShell.vue'


export default {
  __name: 'SettingsBilling',
  setup(__props) {

const { user, capabilities } = useSettingsAccess()

const smsUsage = ref(null)
const smsUsageState = ref('loading')

const formatUsageDate = iso =>
  new Date(iso).toLocaleDateString('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' })

const smsUsagePeriod = computed(() => {
  const attrs = smsUsage.value?.attributes
  if (!attrs?.period_start || !attrs?.period_end) return null
  return `${formatUsageDate(attrs.period_start)} - ${formatUsageDate(attrs.period_end)}`
})

const smsUsageResetsOn = computed(() => {
  const end = smsUsage.value?.attributes?.period_end
  return end ? `Resets on ${formatUsageDate(end)}` : ''
})

const fetchSmsUsage = async () => {
  try {
    const response = await api.call('GET', 'sms_usage', {}, { receive: false })
    if (!response.data.data) {
      smsUsageState.value = 'hidden'
    } else {
      smsUsage.value = response.data.data
      smsUsageState.value = 'loaded'
    }
  } catch {
    smsUsageState.value = 'error'
  }
}

const accountType = computed(() => user.value?.attributes?.stripe_account_type ?? 'none')
const stripeText = computed(() => (accountType.value === 'none' ? 'Connect with Stripe' : 'Stripe'))
const stripeButton = computed(
  () =>
    ({
      none: 'Connect',
      express: 'Go to Stripe account',
      managed: 'Upgrade to Stripe express',
      other: 'Navigate to Stripe'
    })[accountType.value]
)

const clickStripe = () => {
  if (accountType.value === 'none') {
    window.open(`${process.env.VUE_APP_API_BASE_SERVER}express/redirect?state=${Cookies.get('auth_token')}`, '_blank')
  }
  if (accountType.value === 'express') {
    api.call('GET', 'express/login', {}, { noProcessing: true }).then(response => {
      window.open(response.data.link, '_blank')
    })
  }
  if (accountType.value === 'managed') {
    api.call('GET', 'express/convert', {}, { noProcessing: true }).then(response => {
      window.open(response.data.link, '_blank')
    })
  }
  if (accountType.value === 'other') {
    window.open('https://stripe.com', '_blank')
  }
}

const clickManage = () => {
  api.call('GET', 'stripe_merchant_portal').then(response => {
    window.open(response.data.session.url, '_blank')
  })
}

onMounted(fetchSmsUsage)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SettingsShell, null, {
    default: _withCtx(() => [
      _createVNode(SettingsSection, {
        title: "Bottle subscription",
        description: "Your plan, invoices and payment method, managed in Stripe.",
        flush: ""
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700" }, "Manage your Bottle subscription", -1)),
          _createVNode(_unref(NeueButton), {
            type: "secondary",
            onClick: clickManage
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Manage", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!_unref(capabilities).includes('kill-stripe'))
        ? (_openBlock(), _createBlock(SettingsSection, {
            key: 0,
            title: "Payouts",
            description: "Where the money from your orders is paid out, through your Stripe account.",
            flush: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_1, _toDisplayString(stripeText.value), 1),
              _createVNode(_unref(NeueButton), {
                type: "secondary",
                onClick: clickStripe
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(stripeButton.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (smsUsageState.value !== 'hidden')
        ? (_openBlock(), _createBlock(SettingsSection, {
            key: 1,
            title: "Usage",
            description: "Text segments your account has sent this billing period."
          }, {
            default: _withCtx(() => [
              (smsUsageState.value === 'loading')
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Loading..."))
                : (smsUsageState.value === 'error')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Usage unavailable right now"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Text segments used", -1)),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(smsUsage.value.attributes.segments_used.toLocaleString()), 1),
                      (smsUsagePeriod.value || smsUsageResetsOn.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString([smsUsagePeriod.value, smsUsageResetsOn.value].filter(Boolean).join(' - ')), 1))
                        : _createCommentVNode("", true)
                    ]))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

}